<style lang="scss" scoped>
#facewrapper{
  width:300px;
  height: 600px;
  border: 1px solid black;
  // dart-sass dont support /deep/ syntax
  ::v-deep video {
    width: 90%;
    // height: 90%;
  }
}
</style>
<template>
  <div>
    <div id="facewrapper"></div>
    <div id="downloadBox"></div>
    <el-button @click="stopRecord">停止</el-button>
    <el-button @click="startRecord">开始录制</el-button>
  </div>
</template>
<script>
import recordMp4 from '../../mixins/recordMp4';

export default {
  data() {
    return {};
  },
  mounted() {
    const options = {
      video: true,
      audio: {
      echoCancellation: true,
      noiseSuppression: true,
      sampleRate: 44100,
    },
      previewBox: 'facewrapper',
      downloadBox: 'downloadBox',
      streamSource: 'screen',

    };
    this.initStream(options);
  },
  mixins: [recordMp4],
  methods: {},
  components: {},
  created() {},
  props: {},
  watch: {},
};
</script>
